<!-- <div [ngClass]="((bannerList.length <= 0 || bannerNullResponse) && (categoryList.length <= 0 || categoryNullResponse)) ? 'fullpage-loader' : ''">
    <span></span>
    <span></span>
    <span></span>
    <span></span>
    <span></span>
    <span></span>
</div> -->

<app-benner>
</app-benner>
<app-category-list></app-category-list>
<app-product-list></app-product-list>
